import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import reportWebVitals from "./reportWebVitals";
import { initSoundCloudClientIdLifecycle } from "./services/soundcloud";
import soundcloudConfig from "./config/soundcloudConfig";

if (!soundcloudConfig.HAS_MISSING_REQUIRED_PRODUCTION_ENV) {
  initSoundCloudClientIdLifecycle();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log)
reportWebVitals();
